module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./UserListView.js"));
	}, "userListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=userListView!./src/pages/UserMgmt/UserList/UserListView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=userListView!./src/pages/UserMgmt/UserList/UserListView.js
// module chunks = 43